<template>

  <div :class="{row: this.buttonsDef.length}" v-if="render">
    <div :class="{'col-sm-8': this.buttonsDef.length}">
      <div class="form-group input-autocomplete" :data-code="element.code">
        <label :title="tooltip(element.label)">
          {{ t(element.label) }}
          <icons-render v-if="element.icons" :propIcons="element.icons"/>
        </label>
        <input
          v-model="textValue"
          :placeholder="t(element.label)"
          :name="element.name"
          :disabled="element.readonly"
          type="text"
          class="form-control"
          ref="element"
        >
        <div
          v-if="!element.readonly"
          @click="_clear"
          class="input-autocomplete-clear">
          <i class="fa fa-close"></i>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div v-if="this.buttonsDef.length" class="col-sm-4 pl-0 form-element-button-wrapper">
      <form-action-button
        :def="def"
        :buttonsDef="buttonsDef"
        :updateDataRequest="updateDataRequest"
        :formDataChanged="formDataChanged"/>
    </div>
  </div>

</template>

<script>
import SourceLoader             from '../../../model/loader/source-loader'
import IconsRender              from '../../templates/widgets/icons-render'
import FormActionButton         from '../../widgets/forms/form-action-button'
import FormElementButtonsHelper from '../../../model/helper/forms/form-element-buttons-helper'
import FormElementTypes         from '../../../model/FormElementTypes'
import DictionaryLoader         from '@/model/loader/dictionary-loader'

export default {
  name:       'auto-complete',
  components: {
    FormActionButton,
    IconsRender
  },
  props:      {
    def:               {
      type:    Object,
      default: () => {
        return {}
      }
    },
    element:           {
      required: true,
      type:     Object,
      default:  () => {
        return {
          name:     null,
          type:     null,
          dataType: null,
          label:    null,
          source:   {
            required: true,
            type:     Object,
            default:  () => {
              return {}
            }
          },
          items:    {
            type:    Array,
            default: () => {
              return []
            }
          }
        }
      }
    },
    ownValue:          {
      type:    Boolean,
      default: false
    },
    updateDataRequest: {
      type:    Function,
      default: null
    },
    formDataChanged:   {
      type:    Function,
      default: null
    },
    defaultValue:      {
      type:    Object,
      default: null
    }
  },

  data () {
    return {
      textValue:         null,
      originalTextValue: null,
      value:             null,

      callApi:      false,
      buttonsDef:   [],
      responseData: [],
      render:       true
    }
  },

  mounted () {
    this.buttonsDef = FormElementButtonsHelper.getButtonsDef(this.element)

    if (this.element.readonly) {
      return
    }

    let element = $(this.$refs.element),
        options = {
          minLength: 0,
          highlight: true
        },
        source  = {
          name:    this.label,
          display: 'label',
          limit:   9999,
          source:  this._source
        }

    element.typeahead(options, source)

    let selectedEventFired = false
    element.on('typeahead:select', (e, selected) => {
      this.callApi           = true
      this.value             = selected.value
      this.textValue         = selected.label
      this.originalTextValue = this.textValue

      $(this.$refs.element).typeahead('val', this.textValue)
      this._changeValue()
      this._blur()

      selectedEventFired = true
    })

    element.on('typeahead:change', (e, selected) => {
      this.callApi = true

      if (!selected) {
        this._clear()
        return
      }

      if (!this.value || selected !== this.textValue) {
        this.value             = selected ? selected.value : undefined
        this.textValue         = selected ? selected.label : undefined
        this.originalTextValue = this.textValue

        $(this.$refs.element).typeahead('val', this.textValue)
        this._changeValue()
      }
      else {
        if (!this.ownValue) {
          this.textValue = this.originalTextValue
          $(this.$refs.element).typeahead('val', this.textValue)
        }
      }
    })

    // let timeout = () => {}
    element.on('focusout', (e, selected) => {
      // clearTimeout(timeout)
      this.callApi = true

      if (this.ownValue) {
        let value           = $(e.target).val()
        value               = value === '' ? null : value
        const originalValue = this.value
        if (value !== originalValue) {
          this.value     = value
          this.textValue = value
          this._changeValue()
        }
        else {
          return
        }
        if (!selectedEventFired) {
          this._blur()
        }

        selectedEventFired = false
      }
    })

    let triggered = false
    let called = false
    element.on('keydown', (e) => {
      if (!triggered) {
        if (e.key === 'Backspace' || e.key === 'Delete' || !called) {
          this.callApi = true
          called = true
        }
        if (e.ctrlKey) {
          let value = $(e.target).val()

          if (!this.value) {
            this.value = value
          }
          this.textValue = value
          this._changeValue()
        }

        triggered = true
      }
    })

    element.on('keyup', () => {
      triggered = false
    })

    if (this.defaultValue) {
      this.updateValue(this.defaultValue)
    }
  },

  watch: {
    value (newValue) {
      if (newValue === '') {
        this.value = this.value ? this.value : null

        this.value     = null
        this.textValue = null

        this._changeValue()
        this._blur()
      }
    }
  },

  methods: {

    /**
     *
     * @param q
     * @param syncCallback
     * @param asyncCallback
     * @private
     */
    _source (q, syncCallback, asyncCallback) {
      if (!this.callApi && this.value) {
        syncCallback([{ value: this.value, label: this.textValue }])
        return
      }

      if (q === '' && this.textValue) {
        q = this.textValue
      }

      let source        = this.element.source
      source.defaults   = this.$parent.innerValues ? this.$parent.innerValues.getValuesTransformed() : {}
      source.searchText = q
      source.def        = this.def

      const callback = (items, responseData) => {
        asyncCallback(items)
        this.responseData = responseData
      }

      SourceLoader.load(source, callback)
    },

    /**
     *
     * @private
     */
    _changeValue () {
      this._emitEvent('changeValue')
    },

    _blur () {
      this._emitEvent('blur')
    },

    _emitEvent (event) {
      let args = {
        element: this.element,
        value:   this.value,
        stValue: this.textValue
      }

      if (this.element.fieldType === FormElementTypes.autocompleteSpec) {
        for (const responseDataItem of this.responseData) {
          if (responseDataItem[this.element.fieldView] === this.textValue) {
            args['data'] = responseDataItem
          }
        }
      }

      this.$emit(event, args)
    },

    /**
     *
     * @param values
     */
    updateValue (values) {
      this.textValue         = this.value && this.value === values.value ? this.textValue : values.stValue
      this.originalTextValue = values.stValue
      this.value             = values.value

      $(this.$refs.element).typeahead('val', this.textValue)
    },

    /**
     *
     * @param values
     * @param fieldName
     */
    updateHighlighters (values, fieldName) {
      this.element.icons.forEach((icon) => {
        if (icon.def.ColumnName === fieldName) {
          icon.value = JSON.parse(values.value)
        }
      })
    },

    _clear () {
      this.value             = null
      this.textValue         = null
      this.originalTextValue = null
      $(this.$refs.element).typeahead('val', this.textValue)

      this._changeValue()
      this._blur()
    },

    setRender (render) {
      this.render = render
    },

    tooltip (key) {
      return DictionaryLoader.tooltip(key, this.$user.languageCode)
    }
  }

}
</script>
